const ALREADY_SEEN_MEMBER_PROMO_OFFER = 'ALREADY_SEEN_MEMBER_PROMO_OFFER';

export const PREFERENCE_TYPE_EMAIL_MARKETING = 'marketing_emails';
export const PREFERENCE_TYPE_DATA_PRIVACY = 'data_privacy';

export default ALREADY_SEEN_MEMBER_PROMO_OFFER;

export const TOGGLE_SKELETON_WIDTH = '51px';
export const TOGGLE_SKELETON_HEIGHT = '31px';

// Delay before the post-mutation background refresh refetches listUserPreferences.
// Gives Didomi's pending_approval state a few seconds to settle so the refetch
// reflects the change. LPB-1570.
export const PREFERENCE_REFRESH_DELAY_MS = 3000;

// Bounds the optimistic re-grey after a DE email change so the toggle can't stay
// greyed indefinitely if the server never confirms pending. LPB-1570.
export const EMAIL_CHANGE_RECONCILE_TIMEOUT_MS = 15000;

// Per-user key for the last email seen on this device — detects an email change
// between visits (drives the optimistic re-grey). LPB-1570.
export const LAST_EMAIL_STORAGE_PREFIX = 'lm_last_email_';
